<!-- successPart -->
<template>
  <div class="wrapper">
    <div class="content">
      <p>恭喜获得{{videoSubjectName.toString()}}学科专属视频解析服务，快去学习吧~填写地址后，我们会尽快为您邮寄真题实战图书哟。</p>
      <div @click="goStudy" class="btn">去学习</div>
      <img src="https://iqh-zt-pord-cdn.iqihang.com/%E5%BD%A2%E7%8A%B6%402x.png" />
    </div>
  </div>
</template>

<script>

export default {
  components: { },
  props: {
    videoSubjectName: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    };
  },
  methods: {
    goStudy() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goBackTestPaperAnalysisPage');
      } else {
        const questionCallBackUrl = sessionStorage.getItem('questionCallBackUrl');
        if (questionCallBackUrl) {
          window.location.href = questionCallBackUrl;
        } else {
          this.$toast('请前往APP题库页完成刷题');
        }
      }
    },
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .content{
    width: 678px;
    height: 295px;
    background: linear-gradient(47deg, #FFF9F7 0%, #FFF2EC 100%);
    border-radius: 7px;
    margin: 0 auto;
    padding: 36px 43px 0 43px;
    position: relative;
    margin-top: 72px;
    img{
      position: absolute;
      right: 22px;
      bottom: 0;
      width: 168px;
      height: 138px;
    }
    p {
      font-size: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 38px;
    }
    .btn{
      width: 225px;
      height: 58px;
      background: #FE7F41;
      border-radius: 29px;
      text-align: center;
      line-height: 58px;
      font-size: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      margin: 0 auto;
      margin-top: 48px;
    }
  }
}
</style>
